<button 
  type="button"
  [class]="buttonClasses"
  [disabled]="isLoading"
  (click)="onToggle()"
>
  <span 
    *ngIf="showIcons" 
    [class]="iconClass"
    class="material-icons"
    [class.animate-spin]="isLoading"
  >
    {{ currentIcon }}
  </span>
  <span>{{ buttonText }}</span>
</button>